import { v4 as uuid } from 'uuid';
import Action from '../Action';

export default class Divider extends Action {
  constructor() {
    super(uuid());
  }
}
